module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-12.29669648.png";